import {MenuItem} from './MenuItem'
import {useAuth} from "../../../../../app/modules/auth"

import { ApplicantMenuInner } from '../../../../../app/modules/company/layout/ApplicantMenuInner'
import { UserMenuInner } from '../../../../../app/modules/setsco/layout/UserMenuInner'

export function MenuInner() {
  
    const { currentUser }  = useAuth();

    if (! currentUser) {
        return (
        <>
        <MenuItem title="Certificate of Conformity" to='/ccs' />    
        <MenuItem title="Serial Labels" to='/sld' />    
        </>)

    }

    return (currentUser.isSetsco) ? <UserMenuInner /> : <ApplicantMenuInner />;
        
}
